var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('b-spinner',{staticClass:"loading-spinner",attrs:{"variant":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }